import { Component, OnInit } from '@angular/core';
import { FacWasteTypes, FacWasteContainerType } from '../../../../../src/models';
import { TransferHttpService } from '../../../../../src/app/services/transfer-http/transfer-http.service';
import { PermissionsService } from '../../../../../src/app/services/permissions/permissions.service';
import { AimsCommonTableFilterType, AimsCommonTableHeader, AimsCommonTableHeaderType, AimsCommonTablePermissions, TableRowUpdate } from '@aims/common-components';
import { AIMS_NUMERIC_TYPES } from 'src/app/components/aims-numeric/aims-numeric.component';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-environmental-config',
  templateUrl: './environmental-config.component.html',
  styleUrls: ['./environmental-config.component.scss']
})
export class EnvironmentalConfigComponent implements OnInit {

  constructor(private transferHttp: TransferHttpService, 
    public permissions: PermissionsService) { 

    }
  
  
  AIMS_NUMERIC_TYPES = AIMS_NUMERIC_TYPES;
  wasteTypes = this.transferHttp.getHot('ProjectSupport/GetWasteTypes');
  wasteContainerTypes = this.transferHttp.getHot('ProjectSupport/GetWasteContainerTypes');

  initialWasteType = new FacWasteTypes();

  initialWasteContainerType = new FacWasteContainerType();

  wasteTypeTableColumns: AimsCommonTableHeader[] = [
    { key: 'editButton', label: 'Edit', type: 'editButton', filter: false },
    { key: 'wasteType', label: 'Waste Type', type: 'string' },
    { key: 'hazardous', label: 'Haz Mat', type: AimsCommonTableHeaderType.BOOLEAN, filterType: AimsCommonTableFilterType.BOOLEAN, width: 60 },
  ];
  wasteTypeTablePermissions: Observable<AimsCommonTablePermissions> = this.permissions.getDataGridPerms$(this.permissions.ComponentID.EnvironmentalConfig, { export:false});

  wasteContainerTypeTableColumns: AimsCommonTableHeader[] = [
    { key: 'editButton', label: 'Edit', type: 'editButton', filter: false },
    { key: 'containerTypeCode', label: 'Code', type: 'string' },
    { key: 'containerTypeDescription', label: 'Container Type', type: 'string' },
    { key: 'maxAmount', label: 'Max Amount', type: 'dynamic' },
  ];
  wasteContainerTypeTablePermissions: Observable<AimsCommonTablePermissions> = this.permissions.getDataGridPerms$(this.permissions.ComponentID.EnvironmentalConfig, { export:false});



  public handleWasteTypeRowUpdate(update: TableRowUpdate): void {
    var updatedWasteType: FacWasteContainerType = update.newRow as FacWasteContainerType;
    this.saveWasteType(updatedWasteType);
  }

 public saveWasteType(wasteType : FacWasteContainerType): void {
    this.transferHttp.save('ProjectSupport/SaveWasteTypes', wasteType, false).subscribe(() => {
      this.wasteTypes = this.transferHttp.getHot('ProjectSupport/GetWasteTypes');
    });
  }

  public handleWasteContainerTypeRowUpdate(update: TableRowUpdate): void {
    var updatedWasteContainerType: FacWasteContainerType = update.newRow as FacWasteContainerType;
    this.saveWasteContainerType(updatedWasteContainerType);
  }

 public saveWasteContainerType(wasteContainerType : FacWasteContainerType): void {
    this.transferHttp.save('ProjectSupport/SaveWasteContainerTypes', wasteContainerType, false).subscribe(() => {
      this.wasteContainerTypes = this.transferHttp.getHot('ProjectSupport/GetWasteContainerTypes');
    });
  }

  ngOnInit() {
  }

}
